import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import WithKioskProp from '../../hoc/WithKioskProp';
import WithTimezone from '../../hoc/WithTimezone';
import WithShop from '../../hoc/WithShop';
import { getMinutesBeforeReservation, isLessThanPrepayOnlyThreshold } from '../../utils/schedule';

export default compose(
  WithKioskProp,
  WithTimezone,
  WithShop,
  withRouter,
  connect(
    (state, ownProps) => {
      const minutesBeforeReservation = getMinutesBeforeReservation(ownProps.params.reservationTime, ownProps.timezone);

      return {
        isReserveNoPayOnly: ownProps.kiosk && isLessThanPrepayOnlyThreshold(minutesBeforeReservation, ownProps.shop),
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/withKioskIsReserveOnly.js